/* @ngInject */

export default (
  $rootScope,
  $scope,
  $timeout,
  webpage,
  eventService,
  scriptService,
  scriptsService,
  actionService,
  Script
) => {
  $scope.Model = {
    availableScripts: [],
    scriptsList: null,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Retrieve Available Scripts Data
   * --------------------------------------------------------------------------------
   */
  if ($rootScope.CurrentAccount.isAdministrator) {
    loadScripts();
  }

  /*
   * Event Listeners
   * --------------------------------------------------------------------------------
   */
  $scope.$on('scriptDelete', function () {
    scriptsService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.scriptsList.getSelected(),
      scriptService.deleteScript,
      $scope.Model.scriptsList.removeData,
      'script(s)'
    );
  });
  $scope.$on('scriptDuplicate', function () {
    scriptsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.scriptsList.getSelected(),
      scriptService.readScript,
      scriptService.createScript,
      $scope.Model.scriptsList.setDataAppend,
      'name',
      ' copy',
      'script(s)'
    );
  });
  $scope.$on('scriptActivate', function () {
    scriptsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.scriptsList.getSelected(),
      scriptService.updateScript,
      $scope.Model.scriptsList.removeData,
      'script(s)',
      true
    );
  });
  $scope.$on('scriptArchive', function () {
    scriptsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.scriptsList.getSelected(),
      scriptService.updateScript,
      $scope.Model.scriptsList.removeData,
      'script(s)',
      false
    );
  });
  $scope.$on('scriptAdd', function (e, $event) {
    scriptsService.clearCache();
    eventService.scriptEdit({
      event: $event,
      script: null,
      list: $scope.Model.scriptsList
    });
  });

  /*
   * List Events
   * --------------------------------------------------------------------------------
   */
  $scope.scriptEdit = function ($event, script) {
    eventService.scriptEdit({
      event: $event,
      script: script,
      list: $scope.Model.scriptsList
    });
  };
  $scope.scriptEdited = function (script) {
    scriptsService.clearCache();
    if (script.isNew === true) {
      delete script.isNew;
      $scope.Model.scriptsList.setDataAppend(script);
    } else {
      $scope.Model.scriptsList.setDataReplace(script);
    }
  };
  $scope.listChange = function (list, data, isSelected) {
    $scope.$parent.Model.childStateHasSelection = isSelected
      ? isSelected
      : list.isSelectedAny();
  };
  $scope.listReady = function (list) {
    $scope.Model.scriptsList = list;
    $scope.Model.watcher = $scope.$parent.$watch('Model.childStateIsArchive', function (
      newValue,
      oldValue
    ) {
      if (newValue !== oldValue) {
        $scope.Model.isArchive = newValue;
        $scope.Model.isReady = false;
        $scope.Model.watcher();
        loadScripts();
      }
    });
  };

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  function loadScripts() {
    webpage.pageTitle('Loading, please wait');
    scriptsService.getAvailable({ isActive: !$scope.Model.isArchive }).then(function (scripts) {
      webpage.pageTitle('Call scripts : Settings');
      $timeout(function () {
        $scope.Model.availableScripts = scripts;
        $scope.Model.isReady = true;
      });
    });
  }
};
